import { useEffect, useState } from 'react'

/**
 * Tracks which of the given section ids is currently in the reading band.
 * Server-safe: the first id is assumed until the browser reports otherwise.
 */
export const useScrollSpy = (ids: string[], band = 0.4) => {
    const [active, setActive] = useState(ids[0] ?? '')

    useEffect(() => {
        const onScroll = () => {
            let current = ids[0] ?? ''

            for (const id of ids) {
                const el = document.getElementById(id)
                if (!el) continue

                if (el.getBoundingClientRect().top <= window.innerHeight * band) current = id
            }

            setActive(current)
        }

        onScroll()
        window.addEventListener('scroll', onScroll, { passive: true })
        window.addEventListener('resize', onScroll)

        return () => {
            window.removeEventListener('scroll', onScroll)
            window.removeEventListener('resize', onScroll)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ids.join('|'), band])

    return active
}
